// Common color constants for the application
export const colors = {
  // Rating colors
  ratingYellow: '#FFC107',
  
  // Chart colors
  positiveGreen: '#4CAF50',
  negativeRed: '#F44336',
  
  // UI colors
  primaryBlue: '#1976d2',
  secondaryGray: '#546E7A',
  
  // Text colors
  textPrimary: '#1a2027',
  textSecondary: '#546E7A'
};

// Common spacing constants for the application
export const spacing = {
  // Page container horizontal padding
  pageHorizontal: { xs: 0, lg: 0 },
  
  // Page container top padding  
  pageTop: { xs: 2, lg: 4 },
  
  // Page container bottom padding
  pageBottom: { xs: 0, lg: 1 },
  
  // Header section horizontal padding within pages
  headerHorizontal: { xs: 0, md: 2 },
  
  // Main header (business info bar) horizontal padding
  headerBarHorizontal: { xs: 0, lg: 2 },
  
  // Main header (business info bar) top padding
  headerBarTop: { xs: 1.5, lg: 3 },
  
  // Main header (business info bar) bottom padding
  headerBarBottom: { xs: 1, lg: 2 },
  
  // Section bottom margin (between page sections)  
  sectionBottom: { xs: 3, lg: 4 }
};

export default colors; 